export default __webpack_public_path__ + "static/media/espritEquipe.7f248d88.png";